import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Textfield from "../Textfield/Textfield";

const PasswordTextField = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  return (
    <div className="passwordFieldContainer">
      <div className="inputWrapper">
        <Textfield
          id={id}
          name={name}
          label={label}
          type={showPassword ? "text" : "password"}
          value={value}
          autoComplete={autoComplete}
          handleOnChange={onChange}
          onBlur={onBlur}
          error={error}
          helperText={helperText}
        />
        <span className="iconWrapper" onClick={handleTogglePassword}>
          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </span>
      </div>
    </div>
  );
};

export default PasswordTextField;
